import { NumericFormat } from "react-number-format";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 150,
  },
});

const MenuLeftItemWValue = ({
  icon,
  name,
  value,
  className = "",
  isNetItem = false,
  info = "",
}) => {
  return (
    <div className={`ml-transaction-body ${className}`}>
      {icon && (
        <div className="ml-icon-container">
          <img alt={name} src={icon} />
        </div>
      )}
      <div className="ml-transaction-value">
        <div className="ml-transaction-value-container">
          <div className={isNetItem ? "ml-net-item-name" : ""}>{name}</div>
          {info && (
            <CustomWidthTooltip title={info} placement="top">
              <div className="ml-info-value">
                <InfoOutlineIcon fontSize="16px" />
              </div>
            </CustomWidthTooltip>
          )}
        </div>
        <div className="ml-bank-value">
          <NumericFormat
            value={value}
            displayType="text"
            thousandSeparator
            prefix="$"
            renderText={(formattedValue) =>
              isNetItem && Number(value) > 0
                ? `+${formattedValue}`
                : formattedValue
            }
          />
        </div>
      </div>
    </div>
  );
};

export default MenuLeftItemWValue;
